import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
// import Select from "react-select";
import * as Yup from "yup";

function AddInflencerModal({ isOpen, toggle, onSave, isLoadingButton }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone_number: "",
    influencer_code: "",
  });
  const [errors, setErrors] = useState({});

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    email: Yup.string()
      .trim()
      .email("Enter a valid email")
      .required("Email is required"),
    // US phone number formats:
    // Matches: 1234567890, 123-456-7890, (123) 456-7890, 123.456.7890, +1 123-456-7890, 1 1234567890
    phone_number: Yup.string()
      .trim()
      .matches(
        /^(?:(?:\+1|1)\s?)?(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/,
        "Enter a valid US phone number"
      )
      .required("Phone number is required"),
    influencer_code: Yup.string()
      .trim()
      .min(6, "Influencer code must be at least 6 characters")
      .required("Influencer code is required"),
  });

  const handleChange = (e) => {
    const { name, value, options, multiple } = e.target;
    if (multiple) {
      const selected = Array.from(options)
        .filter((o) => o.selected)
        .map((o) => o.value);
      setForm((prev) => ({ ...prev, [name]: selected }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await validationSchema.validate(form, { abortEarly: false });

      if (onSave) onSave(form);

      setForm({
        name: "",
        email: "",
        phone_number: "",
        influencer_code: "",
      });
      setErrors({});
    } catch (validationError) {
      const formatted = {};
      if (validationError.inner && validationError.inner.length) {
        validationError.inner.forEach((err) => {
          if (err.path) formatted[err.path] = err.message;
        });
      } else if (validationError.path) {
        formatted[validationError.path] = validationError.message;
      }
      setErrors(formatted);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add Influencer</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              id="name"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
            {errors.name ? (
              <label className="err-msg">{errors.name}</label>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              id="email"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
            />
            {errors.email ? (
              <label className="err-msg">{errors.email}</label>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label for="phone_number">Phone Number</Label>
            <Input
              id="phone_number"
              type="tel"
              name="phone_number"
              value={form.phone_number}
              onChange={handleChange}
            />
            {errors.phone_number ? (
              <label className="err-msg">{errors.phone_number}</label>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label for="influencer_code">Influencer Code</Label>
            <Input
              id="influencer_code"
              type="text"
              name="influencer_code"
              value={form.influencer_code}
              onChange={handleChange}
            />
            {errors.influencer_code ? (
              <label className="err-msg">{errors.influencer_code}</label>
            ) : null}
          </FormGroup>
          {/* <FormGroup>
            <Label for="products">Products</Label>
            <Select
              inputId="products"
              name="products"
              isMulti
              closeMenuOnSelect={false}
              options={(products && products.length
                ? products
                : [
                    { id: "prod_1", name: "Product 1" },
                    { id: "prod_2", name: "Product 2" },
                  ]
              ).map((p) => {
                const val =
                  typeof p === "string" ? p : p.id || p.value || p.name;
                const label =
                  typeof p === "string" ? p : p.name || p.label || val;
                return { value: val, label };
              })}
              value={((options) => {
                const opts = options || [];
                return form.products
                  .map((v) => opts.find((o) => o.value === v))
                  .filter(Boolean);
              })(
                (products && products.length
                  ? products
                  : [
                      { id: "prod_1", name: "Product 1" },
                      { id: "prod_2", name: "Product 2" },
                    ]
                ).map((p) => {
                  const val =
                    typeof p === "string" ? p : p.id || p.value || p.name;
                  const label =
                    typeof p === "string" ? p : p.name || p.label || val;
                  return { value: val, label };
                })
              )}
              onChange={(selected) => {
                const values = (selected || []).map((s) => s.value);
                setForm((prev) => ({ ...prev, products: values }));
              }}
              placeholder="Select products"
            />
          </FormGroup> */}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={isLoadingButton}>
            {isLoadingButton ? "Please Wait..." : "Save"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default AddInflencerModal;
